import { TLShapeId } from '@tldraw/tldraw'
import { ToolCallResponse } from 'api/clients/AiClient'
import { AIElement, AITextElement } from 'components/VisualStudioPlayground/Templates/Types'

type ToolUse = {
  recipient_name: string
  parameters: string
}

export const processToolCalls = (toolCalls: Array<ToolCallResponse>) => {
  let aiElements: Array<AIElement> = []
  cleanToolCalls(toolCalls).forEach((toolCall) => {
    if (toolCall.function.name === 'replace_styles') {
      const aiElement = JSON.parse(toolCall.function.arguments) as AIElement
      aiElements.push(aiElement)
    } else if (toolCall.function.name === 'replace_text') {
      const textElement = JSON.parse(toolCall.function.arguments) as AITextElement
      const element = {
        id: textElement.id,
        props: {
          text: textElement.text,
        },
      }
      const aiElement = element as AIElement
      aiElements.push(aiElement)
    } else if (toolCall.function.name === 'replace_image') {
      const aiElement = JSON.parse(toolCall.function.arguments) as AIElement
      aiElements.push(aiElement)
    }
  })

  aiElements.forEach((aiElement) => {
    if (!aiElement.id.startsWith('shape:')) aiElement.id = `shape:${aiElement.id}` as TLShapeId
  })

  return aiElements
}

// Sometimes the AI hallucinates a multi_tool_use.parallel function call, which is a single call that contains multiple tool calls.
export const cleanToolCalls = (toolCalls: Array<ToolCallResponse>): Array<ToolCallResponse> => {
  let cleanedToolCalls: Array<ToolCallResponse> = []

  toolCalls.forEach((toolCall) => {
    if (toolCall.function.name === 'multi_tool_use.parallel') {
      const parsedArguments = JSON.parse(toolCall.function.arguments)
      if (parsedArguments.tool_uses) {
        const transformedToolCalls = parsedArguments.tool_uses.reduce(
          (acc: Array<ToolCallResponse>, toolUse: ToolUse) => {
            const functionName = toolUse.recipient_name.split('functions.').pop()
            if (!functionName) {
              return acc
            }
            acc.push({
              id: toolCall.id,
              function: {
                name: functionName,
                arguments: JSON.stringify(toolUse.parameters),
              },
              type: toolCall.type,
            })
            return acc
          },
          [],
        )
        cleanedToolCalls = [...cleanedToolCalls, ...transformedToolCalls]
      }
    } else {
      cleanedToolCalls.push(toolCall)
    }
  })

  return cleanedToolCalls
}
